import { createReducer } from './index';
import { fromJS } from 'immutable';
import * as ActionTypes from '../actions/types';

const defaultCriterion = {
  id: null,
  name: null,
  weightOld: null,
  weightNew: null,
  weightNewComing: null,
  createdDate: null,
  categoryId:  null,
  departmentId:  null,
};

const INITIAL_STATE = fromJS({
  criterion: fromJS(defaultCriterion),
  fetching: false,
  posting: false,
  updating: false,
  message: '',
  deleting: false
});

function createCriterion(state, action) {
  return state
    .set('posting', true)
}

function createCriterionSuccess(state, action) {
  return state
    .set('posting', false)
    .set('message', 'Criterion was created successfully')
    .set('criterion', fromJS(defaultCriterion))
}

function createCriterionFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to create criterion'
  }
  return state
    .set('posting', false)
    .set('message', msg)
}

function getCriterionById(state, action) {
  return state
    .set('fetching', true)
}

function getCriterionByIdSuccess(state, action) {
  return state
    .set('fetching', false)
    .set('criterion', fromJS(action.payload.body))
}

function getCriterionByIdFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to load criterion'
  }
  return state
    .set('fetching', false)
    .set('message', msg)
}

function updateCriterion(state, action) {
  return state
    .set('updating', true)
}

function updateCriterionSuccess(state, action) {
  return state
    .set('updating', false)
}

function updateCriterionFailed(state, action) {
  let msg = '';
  try {
    msg = action.payload.response.body.error.message
  } catch (e) {
    msg = 'Failed to update criterion'
  }
  return state
    .set('updating', false)
    .set('message', msg)
}

function changeCriterionState(state, action) {
  return state
    .set(action.payload.key, action.payload.value)
}

function resetState(state, action) {
  return INITIAL_STATE;
}

function deleteCriterion(state, action) {
  return state
    .set('deleting', true)
}

function deleteCriterionSuccess(state, action) {
  return state
    .set('deleting', false)
}

function deleteCriterionFailed(state, action) {
  return state
    .set('deleting', false)
}

export const criterion = createReducer(INITIAL_STATE, {
  [ActionTypes.CREATE_CRITERION]: createCriterion,
  [ActionTypes.CREATE_CRITERION_SUCCESS]: createCriterionSuccess,
  [ActionTypes.CREATE_CRITERION_FAILED]: createCriterionFailed,
  [ActionTypes.GET_CRITERION_BY_ID]: getCriterionById,
  [ActionTypes.GET_CRITERION_BY_ID_SUCCESS]: getCriterionByIdSuccess,
  [ActionTypes.GET_CRITERION_BY_ID_FAILED]: getCriterionByIdFailed,
  [ActionTypes.UPDATE_CRITERION]: updateCriterion,
  [ActionTypes.UPDATE_CRITERION_SUCCESS]: updateCriterionSuccess,
  [ActionTypes.UPDATE_CRITERION_FAILED]: updateCriterionFailed,
  [ActionTypes.CHANGE_CRITERION_STATE]: changeCriterionState,
  '@@router/LOCATION_CHANGE': resetState,
  [ActionTypes.DELETE_CRITERION]: deleteCriterion,
  [ActionTypes.DELETE_CRITERION_SUCCESS]: deleteCriterionSuccess,
  [ActionTypes.DELETE_CRITERION_FAILED]: deleteCriterionFailed,
});



// WEBPACK FOOTER //
// ./src/reducers/criterion.js